import clsx from 'clsx';
import * as React from 'react';
import { useEffect, useState } from 'react';
import useDraft from '../hooks/useDraft';

export default function SaveDialog() {
    const { draft, changeName } = useDraft();

    const [name, setName] = useState<string>(draft.name);
    useEffect(() => {
        if (!name || name !== draft.name) {
            setName(draft.name);
        }
    }, [draft, setName]);

    function handleSubmit(event) {
        event.preventDefault();
        changeName(name.trim(), draft.id);
    }

    return (
        <>
            <form className="dialog__control-group" onSubmit={handleSubmit}>
                <input
                    name="kite-name"
                    value={name}
                    onChange={({ target: { value } }) => setName(value)}
                />
                <button
                    className={clsx('button', {
                        warning: name !== draft.name,
                    })}
                >
                    rename
                </button>
            </form>
        </>
    );
}
